import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {seasonalCollections,seasonalIssues} from '../data/seasonalCampaigns';

const {FiArrowUpRight,FiCalendar,FiShoppingBag} = FiIcons;

function CampaignCard({campaign,type,onNavigate}) {
  const isCollection = type === 'collection';

  return (
    <article className="campaign-card" style={{'--campaign-accent': campaign.accent}}>
      <div className="campaign-image">
        <img src={campaign.image} alt="" />
        <span>{campaign.number || 'Limited edition'}</span>
      </div>
      <div className="campaign-copy">
        <div className="campaign-meta">
          <SafeIcon icon={isCollection ? FiShoppingBag : FiCalendar} />
          <span>{campaign.label}</span>
        </div>
        <h3>{campaign.title}</h3>
        <p>{campaign.description}</p>
        <button onClick={() => onNavigate(campaign.target)}>
          {campaign.action}
          <SafeIcon icon={FiArrowUpRight} />
        </button>
      </div>
    </article>
  );
}

function SeasonalCampaigns({onNavigate}) {
  return (
    <section className="seasonal-campaigns" id="seasonal">
      <div className="seasonal-heading">
        <div>
          <span className="eyebrow">The seasonal desk</span>
          <p className="script-kicker">New chapters, considered weekly</p>
          <h2>For this season<br />of becoming.</h2>
        </div>
        <p>
          Fresh editorial campaigns and limited collections, gathered in one
          place for wherever life is taking you next.
        </p>
      </div>
      <div className="campaign-grid">
        {seasonalIssues.map((campaign) => (
          <CampaignCard
            key={campaign.title}
            campaign={campaign}
            type="issue"
            onNavigate={onNavigate}
          />
        ))}
        {seasonalCollections.map((campaign) => (
          <CampaignCard
            key={campaign.title}
            campaign={campaign}
            type="collection"
            onNavigate={onNavigate}
          />
        ))}
      </div>
    </section>
  );
}

export default SeasonalCampaigns;